import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { getStore } from "store";
import { StylesProvider , MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { Routes } from "routes/routes";
import { sharedHistory } from "routes/sharedHistory";
import colors from "styles/variables.scss";
import { LoadingOverlay } from "components/Loaders/LoadingOverlay/LoadingOverlay";
import * as serviceWorker from "utils/serviceWorker";
import "utils/connected/interceptors";

export const store = getStore();

const theme = createTheme({
    typography: { useNextVariants: true },
    palette: {
        primary: { main: colors.primary },
        secondary: { main: colors.greenDark }
    }
});

ReactDOM.render(
    <Suspense fallback={<LoadingOverlay />}>
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <StylesProvider injectFirst>
                    <Router
                        history={sharedHistory}
                        children={Routes}
                    />
                </StylesProvider>
            </MuiThemeProvider>
        </Provider>
    </Suspense>,
    document.getElementById("root")
);

serviceWorker.unregister();
